// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen4V2_comp__5mBdM"};